(function ($) {
    function CourseDetail() {
        this._courseDetail = $('.f-course-detail-wrap');
        this._contactForm = null;
        this._token = null;
        this._base_url = null;
        this._customerServiceBtn = null;
        this._customerServiceBox = null;
        this._stickBox = null;
        this._review = null;
        this._totalRating = null;

        this.init();
        this.addListeners();
    }

    CourseDetail.prototype = {
        init: function () {
            const self = this;
            const facultyDirectorElement = self._courseDetail.find('.faculty-director-wrap');
            const agendaElement = self._courseDetail.find('.course-curriculum-wrap.live-agenda');

            self._contactForm = self._courseDetail.find('#contactForm');
            self._base_url = window.pageData.home_url;
            self._token = $("meta[name=csrf-token]").prop('content');
            self._customerServiceBox = $(".contact-info");
            self._customerServiceBtn = $("img.customer-service");
            self._stickBox = $('.introduction .item:nth-of-type(2)');
            self._review = $('#review');
            self._totalRating = $('.introduction .rating');

            facultyDirectorElement.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 7000,
                prevArrow: '<button type="button" class="slick-prev"><i class="la la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="la la-angle-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            });

            agendaElement.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 7000,
                prevArrow: '<button type="button" class="slick-prev"><i class="la la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="la la-angle-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            });

            self.resizeStickBox();
        },

        addListeners: function () {
            let self = this;

            self._courseDetail.find('a[data-target="#contactForm"]').click(function() {
                self._contactForm.find('.msgBlock').empty().hide();
            });

            self._customerServiceBtn.click(function () {
                self._customerServiceBtn.hide();
                self._customerServiceBox.show();
            });

            self._customerServiceBox.find('.close').click(function () {
                self._customerServiceBtn.show();
                self._customerServiceBox.hide();
            });

            self._contactForm.find('button[type=submit]').click(function(event) {
                event.preventDefault();

                self._contactForm.find('p.error').remove();

                if (!self._contactForm.find('[name=accept]').is(":checked")) {
                    self._contactForm.find('[name=accept]')
                        .closest('label')
                        .append('<p class="error" style="margin-bottom: 0; margin-left: 28px;">Please accept our Privacy Policy</p>');

                    return false;
                }

                self._contactForm.find('.msgBlock').empty().html('Sending ...').show();
                self._contactForm.find('button[type=submit]').prop('disabled', true);

                self.recaptchaChallenge('contact_us', function (gRecaptchaResponse) {
                    const postData = new FormData(self._contactForm.find('form')[0]);
                    postData.append('g-recaptcha-response', gRecaptchaResponse);

                    $.ajax({
                        url: self._base_url + '/submit-contact-form',
                        type: 'POST',
                        data: postData,
                        headers: { 'X-CSRF-TOKEN': self._token },
                        contentType: false,
                        cache: false,
                        processData: false
                    }).done(function (response) {
                        if (response.errors) {
                            self._contactForm.find('.msgBlock').empty().hide();

                            $.each(response.errors, function (element, item) {
                                $.each(item, function (index, message) {
                                    if (element == 'g-recaptcha-response') {
                                        $('<p class="px-3 m-0 error" style="color: red;">' + message + '</p>')
                                            .insertBefore(self._contactForm.find('.modal-footer'));
                                    } else {
                                        $('<p class="error" style="color: red;">' + message + '</p>')
                                            .insertAfter(self._contactForm.find('#' + element));
                                    }

                                });
                            });

                            return false;
                        } else {
                            self._contactForm.find('p.error').remove();
                            self._contactForm.find('.msgBlock').empty().html(response.message).show();
                            self._contactForm.find('form input[type=text]').prop('value', '');
                            self._contactForm.find('form input[type=checkbox]').prop('checked', false);
                        }
                    }).fail(function (response, status, error) {
                        alert(error);
                    }).always(function () {
                        self._contactForm.find('button[type=submit]').prop('disabled', false);
                    });
                });
            });

            window.addEventListener('resize', function(event) {
                self.resizeStickBox();
            }, true);

            window.addEventListener('scroll', function(event) {
                self.resizeStickBox();
            }, true);

            self._totalRating.click(function() {
                document.getElementById("review").scrollIntoView({
                    block: "start",
                    behavior: "smooth"
                })
            });

            self._courseDetail.find('.list-skill li').on('click', function () {
                $('html, body').animate({
                    scrollTop: self._courseDetail.find('#curriculum-section').offset().top - 100
                }, 500);
            });
        },

        resizeStickBox: function () {
            let self = this,
                footer = $('footer');

            if (footer.length && $(window).width() > 991) {
                if (window.pageYOffset >= footer.position().top - footer.height() - 100)
                    self._stickBox.find(".stick-content").css({
                        'position': 'fixed',
                        'top': -(footer.height() - 80) + 'px',
                        'width': self._stickBox.width()
                    });
                else if (window.pageYOffset >= 150)
                    self._stickBox.find(".stick-content").css({
                        'position': 'fixed',
                        'top': $(window).width() > 1366 ? '15px' : '120px',
                        'width': self._stickBox.width()
                    });
                else
                    self._stickBox.find('.stick-content').removeAttr('style');
            }
        },

        recaptchaChallenge(action, callback) {
            grecaptcha.execute(pageData.recaptcha_sitekey, {action: action}).then(function(token) {
                callback(token);
            });
        },
    }

    $(document).ready(function () {
        new CourseDetail();
    });
}) (jQuery)
